import {
  FETCH_EASY_JOIN_CODES_START,
  FETCH_EASY_JOIN_CODES_FULFILLED,
  FETCH_EASY_JOIN_CODES_REJECTED,
  CREATE_EASY_JOIN_CODE_START,
  CREATE_EASY_JOIN_CODE_FULFILLED,
  CREATE_EASY_JOIN_CODE_REJECTED,
  UPDATE_EASY_JOIN_CODE_START,
  UPDATE_EASY_JOIN_CODE_FULFILLED,
  UPDATE_EASY_JOIN_CODE_REJECTED,
  DELETE_EASY_JOIN_CODES_START,
  DELETE_EASY_JOIN_CODES_FULFILLED,
  DELETE_EASY_JOIN_CODES_REJECTED,
} from './actionTypes';

const initialState = {
  isLoadingCodes: true,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
  error: null,
};

export default function easyJoinUIReducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_EASY_JOIN_CODES_START:
      return { ...state, isLoadingCodes: true, error: null };
    case FETCH_EASY_JOIN_CODES_FULFILLED:
      return { ...state, isLoadingCodes: false };
    case FETCH_EASY_JOIN_CODES_REJECTED:
      return { ...state, isLoadingCodes: false, error: action.payload };
    case CREATE_EASY_JOIN_CODE_START:
      return { ...state, isCreating: true, error: null };
    case CREATE_EASY_JOIN_CODE_FULFILLED:
      return { ...state, isCreating: false };
    case CREATE_EASY_JOIN_CODE_REJECTED:
      return { ...state, isCreating: false, error: action.payload };
    case UPDATE_EASY_JOIN_CODE_START:
      return { ...state, isUpdating: true, error: null };
    case UPDATE_EASY_JOIN_CODE_FULFILLED:
      return { ...state, isUpdating: false };
    case UPDATE_EASY_JOIN_CODE_REJECTED:
      return { ...state, isUpdating: false, error: action.payload };
    case DELETE_EASY_JOIN_CODES_START:
      return { ...state, isDeleting: true, error: null };
    case DELETE_EASY_JOIN_CODES_FULFILLED:
      return { ...state, isDeleting: false };
    case DELETE_EASY_JOIN_CODES_REJECTED:
      return { ...state, isDeleting: false, error: action.payload };
    default:
      return state;
  }
}
